// Styles
import '../scss/main.scss';

// Scripts
import { offer } from '@shop/frontend/dist/mobile/index';

jQuery(function () {
  offer.getState(function (data) {
    if (data.query.cmp === 'false') {
      $('.cmp-hide').hide();
    }
    const productPrice = '$' + data.products[0].price.toFixed(2);
    $('.product-price').text(productPrice);
  });

  /*accordion*/
  var content = $('.accordion-content');
  content.hide();
  $('.active .accordion-content').slideDown();
  $('.accordion-row').click(function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active').find(content).slideUp();
    } else {
      content.slideUp();
      $('.accordion-row.active').removeClass('active');
      $(this).addClass('active').find(content).slideDown();
    }
  });
  /*accordion end*/

  /*accordion*/
  var content2 = $('.accordion-content2');
  content2.hide();
  $('.active .accordion-content2').slideDown();
  $('.accordion-row2').click(function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active').find(content2).slideUp();
    } else {
      content2.slideUp();
      $('.accordion-row2.active').removeClass('active');
      $(this).addClass('active').find(content2).slideDown();
    }
  });
  /*accordion end*/

  function getRandom(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  $('.results-date').each(function () {
    const currentDate = new Date();
    const randomDays = getRandom(30, 60);
    currentDate.setDate(currentDate.getDate() - randomDays);
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    const month = monthNames[currentDate.getMonth()];
    const day = currentDate.getDate().toString().padStart(2, '0');
    const year = currentDate.getFullYear();
    const reviewDateString = `${month} ${day}, ${year}`;
    $(this).html(reviewDateString);
  });
});
